<form [formGroup]="group">
    <EIPAutoComplete TextField="displayText" ValueField="dedId" [WaterMarkText]="waterMarkText"
        [formControlName]="formFieldName" [setId]="controlId" ShowTextValueField='N' [dataSource]="field.values"
        [IsCascading]='true' [defaultValue]="selectedDedId" [SingleValueBind]="false"
        (valueChange)='onselectedValueChange($event)'>
    </EIPAutoComplete>
    <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
        <mat-error *ngIf="group.get(formFieldName).touched && group.get(formFieldName).hasError(validation.name)"
            style="margin-top: -15px;">{{validation.message}}
        </mat-error>
    </ng-container>
</form>
